// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pixL1","label":"styles_label__44Rs5"};